import { render, staticRenderFns } from "./root.vue?vue&type=template&id=7ef64468&scoped=true"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"
import style0 from "./root.vue?vue&type=style&index=0&id=7ef64468&prod&lang=scss"
import style1 from "./root.vue?vue&type=style&index=1&id=7ef64468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef64468",
  null
  
)

export default component.exports